// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_j5-0";
export var fileCarousel = "_j5-2";
export var removeFileButton = "_j5-1";